import styled from "styled-components";

export const FooterContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 50px;

  p:last-child {
    font-size: 0.8rem;
  }
`;
